import { useMutation } from '@apollo/client';

import { VatAmountFragmentDoc } from 'common/graphql/fragments/vatAmount.gql';
import logger from 'helpers/logger';

import { UpdateVatAmountDocument } from './update-vat-amount.gql';

const useUpdateVatAmount = () => {
  return useMutation(UpdateVatAmountDocument, {
    update: (cache, { data }) => {
      if (!data || !data.updateVatAmount.receiptId) {
        logger.error('Incorrect data from updateVatAmount mutation');
        return;
      }
      cache.modify({
        fields: {
          vatAmount: () =>
            cache.writeFragment({
              data: data.updateVatAmount,
              fragment: VatAmountFragmentDoc,
            }),
        },
        id: cache.identify({
          __typename: 'Receipt',
          receiptId: data.updateVatAmount.receiptId,
        }),
      });
    },
  });
};

export default useUpdateVatAmount;
